import restoreScroll from 'redux-first-router-restore-scroll';
import { compose } from 'ramda';
import qs from 'qs';

import { isClient } from '../lib/utils';
import { pageNameByType } from '../lib/routes/pageNames';
import { trackPage } from '../lib/analytics';

import { detectTheme } from './theme/actions';
import { removeNotification } from './notifications/actions';
import { rememberIsQaTeam, rememberSuperchargerPromo } from './session/actions';

function setTheme(action, dispatch) {
  const { pathname, query } = action.meta?.location?.current || {};
  const value = query?.product || pathname;

  compose(dispatch, detectTheme)(value);
}

export default {
  onBeforeChange(dispatch, getState) {
    // always dispatching this action was causing unnecessary renders
    // in some components
    if (getState()?.notifications?.notification) dispatch(removeNotification());
  },
  onAfterChange(dispatch, getState, { action }) {
    if (isClient) {
      const currentPageName = pageNameByType(action.type, window.PAGES || []);
      trackPage(currentPageName);
      rememberSuperchargerPromo(
        dispatch,
        action.meta?.location?.current?.query
      );
      rememberIsQaTeam(
        dispatch,
        action.meta?.location?.current?.query,
        action.meta?.location?.current?.pathname
      );
    }
    setTheme(action, dispatch);
  },
  restoreScroll: restoreScroll(),
  querySerializer: qs,
};
